import React from 'react';
import { IOrder, IOrderPallet } from '@/interfaces/order';
import { Col, Row, Space, TableProps } from 'antd';
import { formatDate } from '@/utils/dataUtils';
import TableComponent from '@/components/table';
import { dateTimeFormat } from '@/configs/dateFormat';
import Title from '@/components/title';

interface IProps {
  data: IOrder;
}

const DeliveryPallet = ({ data }: IProps) => {
  const columns: TableProps<IOrderPallet>['columns'] = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      align: 'center',
      className: 'text-center',
      render: (_, rec, i) => <Space>{i + 1}</Space>,
    },
    {
      title: 'Pallet Number',
      dataIndex: 'palletNumber',
      key: 'palletNumber',
      className: 'font-bold',
      align: 'center',
    },
    {
      title: 'CHECK IN',
      dataIndex: 'receivedDate',
      key: 'receivedDate',
      className: 'font-bold',
      align: 'center',
      render: _ => (_ && formatDate(_, dateTimeFormat)) || '',
    },
    {
      title: 'ON DELIVERY',
      dataIndex: 'deliveryedDate',
      key: 'deliveryedDate',
      className: 'font-bold',
      align: 'center',
      render: _ => (_ && formatDate(_, dateTimeFormat)) || '',
    },
    {
      title: 'ทะเบียนรถ',
      dataIndex: 'orderDriverId',
      key: 'orderDriverId',
      className: 'font-bold',
      align: 'center',
      render: (_, rec) => {
        const driver = data?.orderDrivers?.find(
          d => d.id === rec.orderDriverId,
        );

        return driver?.tabian || '';
      },
    },
    {
      title: 'ชื่อคนขับ',
      dataIndex: 'orderDriverId',
      key: 'orderDriverId',
      className: 'font-bold',
      align: 'center',
      render: (_, rec) => {
        const driver = data?.orderDrivers?.find(
          d => d.id === rec.orderDriverId,
        );

        return driver?.driverName || '';
      },
    },
  ];

  return (
    <Row gutter={12} className="">
      <Col span={24}>
        <div className="border-2 border-dashed rounded-md px-3 pb-4">
          <Title title="Pallet" />
          <TableComponent<IOrderPallet>
            columns={columns}
            data={{
              data: data?.orderPallets || [],
              totalRecords: 0,
            }}
            loading={false}
            showPagination={false}
            scroll
          />
        </div>
      </Col>
    </Row>
  );
};

export default DeliveryPallet;
